import React from 'react';
import { SOLUTION_PAGE_HEROES } from '../../../../content/enterpriseMessaging';

export default function ProductOverview() {
  const copy = SOLUTION_PAGE_HEROES.semanticHr;

  return (
    <div className="container-x py-16 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
        <div className="max-w-3xl">
          <p className="eyebrow">{copy.eyebrow}</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
            {copy.productOverviewTitle}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-600">{copy.productOverviewBody}</p>
        </div>

        <div className="space-y-4">
          <div className="rounded-xl border border-brand-100 bg-brand-50 px-6 py-5">
            <p className="text-sm font-semibold text-brand-800 mb-2">Power BI + Snowflake visualization</p>
            <p className="text-base text-ink-700 leading-relaxed">
              Semantic HR couples two visualization layers on the same answer.{' '}
              <strong>Agentic Power BI</strong> opens the governed executive dashboard for the question, bookmark
              and filters applied automatically. Where the Snowflake query result supports it, a{' '}
              <strong>live Snowflake visualization</strong> is generated beneath the embed from the exact rows
              returned, curated report view plus an immediate chart of the ad-hoc answer.
            </p>
          </div>

          <div className="rounded-xl border border-ink-200 bg-surface-muted px-6 py-5">
            <p className="text-sm font-semibold text-ink-900 mb-2">Progressive workforce inquiry</p>
            <p className="text-base text-ink-600 leading-relaxed">
              Start with headcount, follow into attrition and hiring, then plan variance and sensitivity,
              each turn keeps dashboard memory and certified definitions without exporting to spreadsheets.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10 lg:mt-12 max-w-4xl">
        <div className="rounded-2xl border border-ink-200 bg-white p-6 sm:p-8 border-l-4 border-l-brand-500 shadow-xs">
          <p className="eyebrow mb-3">Starting simple</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <p className="text-xs font-semibold text-ink-500 uppercase tracking-wide mb-1.5">Natural language</p>
              <div className="bg-surface-muted rounded-lg px-4 py-3 font-mono text-sm text-ink-800 border border-ink-200">
                &ldquo;What is our current active headcount by department?&rdquo;
              </div>
            </div>
            <div>
              <p className="text-xs font-semibold text-ink-500 uppercase tracking-wide mb-1.5">Semantic HR response</p>
              <p className="text-base text-ink-600 leading-relaxed">
                A plain-language headcount summary with supporting numbers, the headcount Power BI dashboard opens
                pre-filtered by department, and when the result shape allows, a Snowflake visualization charts the
                same live query output beneath it.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
